import styles from './AdoptionSection.module.css'

type AdoptionRow = {
  challenge: string
  solution: string
}

export type AdoptionSectionData = {
  titleOrange: string
  titleBlack: string
  subtitle: string
  headerChallenge: string
  headerSolution: string
  rows: AdoptionRow[]
}

type AdoptionSectionProps = {
  data: AdoptionSectionData
}

const AdoptionSection = ({ data }: AdoptionSectionProps) => {
  const {
    titleOrange,
    titleBlack,
    subtitle,
    headerChallenge,
    headerSolution,
    rows,
  } = data

  return (
    <section className={styles.challengesSection}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-lg-5">
            <h2 className={styles.sectionTitle}>
              <span className={styles.titleBlack}>{titleOrange}</span>{' '}
              {titleBlack}
            </h2>
            <p className={styles.subtitle}>{subtitle}</p>
          </div>
          <div className="col-12 col-lg-6">
            <div className={styles.tableTitle}>AI in Marketing</div>
            <div className={styles.tableWrapper}>
              <table className={styles.table}>
                <thead>
                  <tr className={styles.headerRow}>
                    <th className={styles.headerChallenge}>
                      {headerChallenge}
                    </th>
                    <th className={styles.headerSolution}>{headerSolution}</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr
                      key={`${row.challenge}-${row.solution}`}
                      className={styles.row}
                    >
                      <td className={styles.challengeCell}>{row.challenge}</td>
                      <td className={styles.solutionCell}>{row.solution}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AdoptionSection
